<template>
  <signal-overlay
    :id="getInstanceId(signal.instance, signal.page_number, signal.signalName)"
    :image-position-multiplier="imagePositionMultiplier"
    :document-page="documentPage"
    :file-type="document.file_type"
    :rotation="rotation"
    :zoom-factor="zoomFactor"
    :signal="signal"
    :keep-visible="true"
  >
    <i-tooltip
      :target="
        '#' +
        getInstanceId(signal.instance, signal.page_number, signal.signalName)
      "
      :title="title()"
      :description="description"
      :info-type="iTooltipInfoTypes.WARNING"
      :alignment="iTooltipAlignmentMode.TOP_MIDDLE"
    >
    </i-tooltip>
  </signal-overlay>
</template>

<script>
import {
  iTooltip,
  iTooltipAlignmentMode,
  iTooltipInfoTypes,
} from '@inscribe/signal';
import SignalOverlay from './SignalOverlay';
import * as signalNames from '../../../constants/signalNames';
import { getInstanceId } from '@/utils/signalNames';
import humanizeString from 'humanize-string';
import { mapGetters } from 'vuex';

export default {
  components: {
    iTooltip,
    'signal-overlay': SignalOverlay,
  },
  props: {
    imagePositionMultiplier: {
      type: Object,
      required: true,
    },
    document: {
      type: Object,
      required: true,
    },
    documentPage: {
      type: Node,
      default: () => null,
    },
    rotation: {
      type: Number,
      required: true,
    },
    signal: {
      type: Object,
      required: true,
    },
    zoomFactor: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      problemReported: false,
      signalNames,
      iTooltipAlignmentMode,
      iTooltipInfoTypes,
      ids: [],
      instanceEnabled: true,
    };
  },
  computed: {
    description() {
      let description = `${
        this.signal.description ? `${this.signal.description} ` : ``
      }on this page.`;
      if (
        this.signal.signalName === signalNames.MASKING ||
        this.signal.signalName === signalNames.MASKING_LIMITED
      ) {
        description += ` The hidden text is shown below`;
      }
      if (
        this.signal.signalName === signalNames.ANNOTATIONS &&
        this.signal.instance?.annotation_type
      ) {
        description += ` Annotation type: ${this.signal.instance?.annotation_type}`;
      }
      return description || '';
    },
    instance() {
      return this.signal.instance;
    },
  },
  mounted() {
    const instanceId = getInstanceId(
      this.signal.instance,
      this.signal.page_number,
      this.signal.signalName,
    );
    this.instanceEnabled = !this.getDisabledInstances().includes(instanceId);
  },

  methods: {
    ...mapGetters(['getDisabledInstances']),
    getInstanceId,
    title() {
      return humanizeString(this.signal.signalName);
    },
  },
};
</script>
